import type { AnalyticsUser } from './types';

/**
 * Identify user to Tiktok Pixel.
 *
 * @param user
 */
export const setUserForTatariPixel = async (user: AnalyticsUser): Promise<void> => {
  if (window.tatari) {
    window.tatari.identify(user.id);
  }
};

/**
 * Track signup conversion.
 */
export const trackSignedUpForTatari = (): void => {
  if (window.tatari) {
    window.tatari.track('Signup');
  }
};

/**
 * Track onboarded conversion.
 */
export const trackOnboardedForTatari = (): void => {
  if (window.tatari) {
    window.tatari.track('Onboarded');
  }
};
